import { render, staticRenderFns } from "./ApplicationUploadsReview.vue?vue&type=template&id=773b0c36&scoped=true&"
import script from "./ApplicationUploadsReview.vue?vue&type=script&lang=js&"
export * from "./ApplicationUploadsReview.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationUploadsReview.vue?vue&type=style&index=0&id=773b0c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773b0c36",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAvatar,VCard,VCardText,VCol,VIcon,VRow,VToolbar,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('773b0c36')) {
      api.createRecord('773b0c36', component.options)
    } else {
      api.reload('773b0c36', component.options)
    }
    module.hot.accept("./ApplicationUploadsReview.vue?vue&type=template&id=773b0c36&scoped=true&", function () {
      api.rerender('773b0c36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploads/components/ApplicationUploadsReview.vue"
export default component.exports